import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

// import {onAddCustomerRes} from './helper';

const addCustomer = async (data: CustomerReqT) =>
  axios.post(Routes.ADD_CUSTOMER, data);

export const useAddCustomer = () =>
  useMutation({
    mutationKey: [Keys.ADD_CUSTOMER_MUT],
    mutationFn: addCustomer,
    // onSuccess: onAddCustomerRes,
  });
